import React from 'react'

export const CaretUpIcon = ({ $dark }: { $dark: boolean }) => {
    return (
        <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.00003 7.99988L7.50003 1.99988L14 7.99988" stroke={$dark ? 'black' : 'white'} strokeWidth="2" />
        </svg>
    )
}
